import { useContext } from "react";
import { FileField, FileInput, required, SimpleFormIteratorItemContext } from "react-admin";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { Box, Typography } from "@mui/material";

const ACCEPTED_FILES = {
  "image/*": [".jpg", ".jpeg", ".png"],
  "application/pdf": [".pdf"],
  "application/msword": [".doc"],
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [".docx"],
};

const FileInputWithlabel = ({
  source = "document",
  label,
  displayLabel,
  placeholderText = "Прикачи снимка на документ",
  isEnableValidate,
  validate,
}) => {
  // Also rendered outside a SimpleFormIterator, where useSimpleFormIteratorItem would throw.
  const index = useContext(SimpleFormIteratorItemContext)?.index;

  // `displayLabel` wins for non-photo documents, where the photo prefix would read wrong.
  const resolvedLabel =
    displayLabel ?? (label ? `Снимка на ${label}` : `Снимка на документ ${index != null ? "№" + (index + 1) : ""}`);

  return (
    <FileInput
      accept={ACCEPTED_FILES}
      placeholder={
        <Box sx={{ display: "flex", justifyContent: "center", gap: 2, py: 0.5 }}>
          <UploadFileIcon color="primary" />
          <Typography>{placeholderText}</Typography>
        </Box>
      }
      label={resolvedLabel}
      source={source}
      validate={validate ?? (isEnableValidate ? required() : undefined)}
    >
      <FileField
        source="src"
        title="title"
      />
    </FileInput>
  );
};

export default FileInputWithlabel;
